//utils
import { batchActions } from 'redux-batched-actions';
import {displayErrorMessage, displaySuccessMessage} from 'utils/messages'
// API Calls Utils
import {
    asyncGetGeneralInfo, asyncUpdateGeneralInfo,
    asyncGetUsers,
    asyncEditUserInfo, asyncDeleteUser,
    asyncAddUser, asyncGetCheckInformation,
    asyncGetACHInformation, asyncGetPayPalInformation,
    asyncGetWireTransferInformation, asyncSavePaymentInformation,
    getAgreement, updateAgreement, asyncGetPaymentInformation, asyncGetAdsTxt,
    asyncVerifyAdsTxt, getAllSitesCall, asyncUpdatePaymentInformation, asyncResendInvite
} from 'utils/api/account';
// THUNK Wrappers for API Calls
import { getFormDataOrRepopulate, updateFormDataWithValidation} from 'state/actions/shared_form_actions';
// import {batchActions} from "redux-batched-actions";
// import


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const RECEIVE_ALL_SITES = 'RECEIVE_ALL_SITES';
export const CHANGE_PAYMENT_TYPE = 'CHANGE_PAYMENT_TYPE';
export const UPDATE_PREFERRED_PAYMENT_TYPE = 'UPDATE_PREFERRED_PAYMENT_TYPE';
export const GET_AGREEMENT_INFO = "GET_AGREEMENT_INFO";
export const UPDATE_AGREEMENT_INFO = "UPDATE_AGREEMENT_INFO";
export const GET_PAYMENT_INFO = "GET_PAYMENT_INFO";
export const FETCHING_PAYMENT_INFO = "FETCHING_PAYMENT_INFO";
export const UPLOAD_FILE = "UPLOAD_FILE";
export const DISCARD_FILE = "DISCARD_FILE";
export const CLEAR_CHECK_ADDRESS = "CLEAR_CHECK_ADDRESS";
export const USE_GENERAL_ADDRESS_CHECK = "USE_GENERAL_ADDRESS_CHECK";
export const GET_GENERAL_INFO_CHECK = "GET_GENERAL_INFO_CHECK";
// export const FETCHING_PAYMENT_INFO = "FETCHING_PAYMENT_INFO";

export const GET_USERS = "GET_USERS";
export const UPDATE_USER = "UPDATE_USER";
export const POPULATE_EDIT_USER_FIELD = "POPULATE_EDIT_USER_FIELD";
export const ADD_USER = "ADD_USER";
export const DELETE_USER = "DELETE_USER";
export const SENDING_INVITE = "SENDING_INVITE";

//AdsTxt
export const GET_ADS_TXT = "GET_ADS_TXT";
export const VERIFY_ADS_TXT = "VERIFY_ADS_TXT";
export const ADS_TXT_FETCHING = "ADS_TXT_FETCHING";




// ACTIONS
// TODO Put action creators in place. Replace actions with action creator calls in thunks

const receiveAllSites = sites => ({
    type: RECEIVE_ALL_SITES,
    sites
});



// -------------- ++++++++ -------------- START: THUNKS -------------- ++++++++ -------------- //


//General Information Actions
export const getGeneralInfoOrRepopulate = (hasStoredData, accountUIID) => getFormDataOrRepopulate('generalInformation', asyncGetGeneralInfo, hasStoredData, accountUIID);
export const updateGeneralInformationWithValidation = (fields, updatedData, accountUUID) => updateFormDataWithValidation('generalInformation', fields ,asyncUpdateGeneralInfo, updatedData, accountUUID);

//Edit Users Actions

const receiveUsers = users => ({
    type: GET_USERS,
    users
});
export const getUsers = (accountUUID) => dispatch => {
 return asyncGetUsers(accountUUID)
     .then(response =>{
         return dispatch(receiveUsers(response.data))
     })
     .catch(err => dispatch(displayErrorMessage('There was an issue fetching your users')))
};

const confirmUserDeleted = (index) => ({
    type: DELETE_USER,
    index
});

export const deleteUser = (userUUID, index) => dispatch => {
    return asyncDeleteUser(userUUID)
        .then(response => {
            return dispatch(confirmUserDeleted(index))
        })
        .catch(err => dispatch(displayErrorMessage('There was an issue deleting this user')))
};

export const populateEditUserForm = (data) => ({
    type: POPULATE_EDIT_USER_FIELD,
    data
});

export const updateUserInformationWithValidation = (fields, updatedData, userUUID, successAction, failAction) => updateFormDataWithValidation('editUser', fields, asyncEditUserInfo, updatedData, userUUID, successAction, failAction);

export const updateTableWithNewUserInformation = (response , index) => ({type: UPDATE_USER, data:response.data, index});

//Add User Actions

export const addUser = (fields, data, accountUUID, successAction, failAction) => updateFormDataWithValidation('addUser', fields, asyncAddUser, data, accountUUID, successAction, failAction );

export const addUserToTable = (response) => ({
        type: ADD_USER,
        user: response.data
    });
//Resend Invite
const sendingInvite = (userUUID) => ({
    type: SENDING_INVITE,
    userUUID
});

export const resendInvite = userUUID => dispatch => {
    //we are pushing userUUID in to the sendingInvite array in reducer
    dispatch(sendingInvite(userUUID));
    asyncResendInvite(userUUID)
        .then(response => {
            dispatch(batchActions([
                //we are splicing userUUID from the sendingInvite array in reducer
                sendingInvite(userUUID),
                displaySuccessMessage('Invite was successfully sent!')
            ]))
        })
        .catch(() => {
            dispatch(batchActions([
                //we are splicing userUUID from the sendingInvite array in reducer
                sendingInvite(userUUID),
                displayErrorMessage('There was an issue sending invite')
            ]))
        })
};
//Payment Information Actions
const receivePaymentInformation = (data) => ({
    type: GET_PAYMENT_INFO,
    payoutThreshold: data.payoutThreshold,
    paymentInfo: data.paymentInfo,
    paymentTypes: data.paymentTypes
});

export const getPaymentInformation = (accountUUID) => dispatch => {
            dispatch(fetchingPaymentInfo());
    return asyncGetPaymentInformation(accountUUID)
        .then(response =>{
            return dispatch(receivePaymentInformation(response.data))
        })
        .catch(err => dispatch(displayErrorMessage('There was an issue fetching your Payment Information')))
};

const fetchingPaymentInfo = () => ({type: FETCHING_PAYMENT_INFO});

export const getCheckInformation = (hasStoredData, formName, paymentUUID) => getFormDataOrRepopulate(formName, asyncGetCheckInformation, hasStoredData, paymentUUID );

export const getPayPalInformation = (hasStoredData, formName, accountUUID) => getFormDataOrRepopulate(formName, asyncGetPayPalInformation, hasStoredData, accountUUID );

export const getACHInformation = (hasStoredData, formName, accountUUID) => getFormDataOrRepopulate(formName, asyncGetACHInformation, hasStoredData, accountUUID );

export const discardFile = (formName) => ({ type: DISCARD_FILE, formName });

export const uploadFile = ( file, formName ) => ({ type: UPLOAD_FILE, file, formName });

export const getWireTransferInformation = (hasStoredData, formName, accountUUID) => getFormDataOrRepopulate(formName, asyncGetWireTransferInformation, hasStoredData, accountUUID );

export const savePaymentInformationWithValidation = (fields, updatedData, paymentType, accountUUID, successAction, failAction) => updateFormDataWithValidation(paymentType, fields, asyncSavePaymentInformation, updatedData, accountUUID, successAction, failAction);

export const updatePaymentInformationWithValidation = (fields, updatedData, paymentType, paymentUUID, successAction, failAction) => updateFormDataWithValidation(paymentType, fields, asyncUpdatePaymentInformation, updatedData, paymentUUID, successAction, failAction);
// -------------- ++++++++ -------------- END: THUNKS -------------- ++++++++ -------------- //


// ACTIONS THAT CAN BE IMPORTED AND USED IN COMPONENTS


export const changePaymentType = (paymentType, paymentUUID) =>({
    type: CHANGE_PAYMENT_TYPE,
    paymentType,
    paymentUUID
});

export const updatePreferredPaymentType = paymentType =>({
    type: UPDATE_PREFERRED_PAYMENT_TYPE,
    paymentType
});

export const getAllSites = accountUUID => dispatch =>{
    return getAllSitesCall(accountUUID)
        .then(response => dispatch(receiveAllSites(response.data)))
        .catch(err => dispatch(displayErrorMessage('There was an issue fetching your Sites')))
};

//-=-=-=-=-=- AGREEMENT THUNKS =-=-=-=-=-=-=-=-=-=//
const receiveAgreementInfo = (data) => ({
    type: GET_AGREEMENT_INFO,
    data
});

export const getAgreementInfo = (accountUUID)=> dispatch => {
    return getAgreement(accountUUID)
        .then(response => {
            return dispatch(receiveAgreementInfo(response.data))
        })
        .catch(err => dispatch(displayErrorMessage('There was an issue fetching your Agreement Information')))
};

const receiveAgreement = data => ({
    type: UPDATE_AGREEMENT_INFO,
    data
});

export const updateAgreementInfo = (agreementUUID)=> dispatch => {
    return updateAgreement(agreementUUID)
        .then(response => {
            return dispatch(receiveAgreement(response.data))
        })
        .catch(displayErrorMessage('There was an issue updating your Agreement Information'))
};

// -=-=-=-=--=-=-=-=-== ADStxt Thunks -=-==-=-=-=-=-=-=-=-=- //
const receiveAdsTxt = (data, site) => ({
    type: GET_ADS_TXT,
    adsTxt: data,
    site
});
export const getAdsTxt = (paramString, site) => dispatch => {
    adsTxtFetching(true);
    return asyncGetAdsTxt(paramString)
        .then(response => {
            return dispatch(receiveAdsTxt(response.data, site))
        },err => dispatch(batchActions([
            adsTxtFetching(false),
            displayErrorMessage('There was an issue fetching your Ads.txt information')]
        )))
};

const adsTxtFetching = (bool) => ({type: ADS_TXT_FETCHING, bool});

const adsTxtVerification = (data) => ({
    type: VERIFY_ADS_TXT,
    adsTxt: data
});
export const verifyAdsTxt = (paramString) => dispatch => {

    return asyncVerifyAdsTxt(paramString)
        .then(response =>{
            return dispatch(adsTxtVerification(response.data))
        })
        .catch(err => dispatch(displayErrorMessage('There was an issue verifying your Ads.txt file')))
};






